import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DynamicScriptLoaderService } from '../../../services/dynamic-script-loader.service';
import { WhatsappService } from '../whatsapp.service';
import { IMessage } from '../../../services/websocket';
import { Subscription } from 'rxjs';
import { AllService } from '../../../services/all.service';
import { Router } from '@angular/router';
declare const QRCode: any;
@Component({
  selector: 'app-sign-whatsapp',
  templateUrl: './sign-whatsapp.component.html',
  styleUrls: ['./sign-whatsapp.component.scss']
})
export class SignWhatsappComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  @ViewChild('qrcode') qrcodeElement: ElementRef;
  public qr: string;
  private qrcode: any;
  public loadingQR = false;
  private qrTimeout: NodeJS.Timeout;
  private qrTimeoutLoading: any;
  constructor(
    private router: Router,
    public allService: AllService,
    private cd: ChangeDetectorRef,
    public whatsappService: WhatsappService,
    public dynamicScriptLoaderService: DynamicScriptLoaderService
  ) {}
  ngOnInit(): void {
    this.dynamicScriptLoaderService.load(['qrcode']).then(() => {
      //
      this.subscriptions.push(
        this.whatsappService.wsService.on<IMessage>('qr').subscribe((data) => {
          this.setQrCode(data.qr);
        })
      );
    });
  }
  setQrCode(qr: string) {
    this.loadingQR = false;
    this.qr = qr;
    if (!this.qrcode) {
      this.qrcode = new QRCode(this.qrcodeElement.nativeElement, {
        text: qr,
        width: 240,
        height: 240,
        colorDark: '#122E31',
        colorLight: 'rgba(0,0,0,0)',
        correctLevel: QRCode.CorrectLevel.L
      });
    } else {
      clearTimeout(this.qrTimeout);
      this.qrTimeout = setTimeout(() => {
        this.qr = undefined;
        this.cd.detectChanges();
      }, 21000);

      this.qrcode.clear(); // clear the code.
      this.qrcode.makeCode(qr); // make another code.
    }
    this.cd.detectChanges();
  }
  getQR() {
    this.whatsappService.startConnect();
    this.loadingQR = true;
    setTimeout(() => {
      this.loadingQR = false;
    }, 25000);
  }
  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
